import { AccountTabTypeEnum } from "../../types/AccountTabTypeEnum";
import { DeviceTabTypeEnum } from "../../types/DeviceTabTypeEnum";

const routes = {
  dashboard: {
    get: () => "/dashboard",
  },
  store: {
    get: () => "/store",
  },
  product: {
    get: () => "/store/products/:productId",
    set: (productId: string) => `/store/products/${productId}`,
  },
  account: {
    get: () => "/accounts/:accountId/:tabIndex?",
    set: (accountId: string, tab = AccountTabTypeEnum.AccountInformation) =>
      `/accounts/${accountId}/${tab}`,
  },
  installation: {
    get: () => "/accounts/:accountId/installations/:installationId",
    set: (accountId: string, installationId: string) =>
      `/accounts/${accountId}/installations/${installationId}`,
  },
  device: {
    get: () =>
      "/accounts/:accountId/installations/:installationId/devices/:deviceId/:tabIndex/:action?",
    set: (
      accountId: string,
      installationId: string,
      deviceId: string,
      tab = DeviceTabTypeEnum.Overview,
      action?: "core-device-widget",
    ) =>
      `/accounts/${accountId}/installations/${installationId}/devices/${deviceId}/${tab}${action ? `?action=${action}` : ""}`,
  },

  search: {
    get: () => "/search",
  },
  403: {
    get: () => "/403",
  },
  404: {
    get: () => "/404",
  },
};

export { routes };
